export default function getData3dInspectorUrl (storageId) {
  // TODO: replace spaces SDK with mini app to inspect data3d files
  return 'https://spaces.archilogic.com/3d/?mode=sdk&file='+storageId
}